import React, { useEffect, useState } from "react";
import { getLogs } from "./_requests";

export function RecordLogs(recordId, recordModel) {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    getLogs(recordId, recordModel)
      .then((result) => {
        setLogs(result.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div>
      <ul className={"list-unstyled"}>
        {logs.map((log) => (
          <li
            className={"alert alert-primary d-flex justify-content-between"}
            key={log.id}
          >
            <span>{log.message}</span>
            <span>
              {new Date(log.createDate).toLocaleString("fa-IR")} - {log.creator}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
